'use client'

// import * as Sentry from '@sentry/nextjs'
import NextError from 'next/error'
import { appsignal } from "./appsignal"
import { useEffect } from 'react'

export default function GlobalError ({ error }) {
  useEffect(() => {
    // Sentry.captureException(error)
    appsignal.sendError(error)
  }, [error])

  return (
    <html lang="en">
      <body>
        <NextError />
      </body>
    </html>
  )
}
